import Big from 'big.js'

const costQuantityRateTotal = (cost, conversion, rate) => {
  return new Big(cost).div(conversion).times(rate)
}

const cropOtherIncomeItem = (incomeItemId, incomeItem, otherIncomeItem) => {
  const total = costQuantityRateTotal(otherIncomeItem.price, 1, incomeItem.quantity)

  return {
    id: incomeItemId,
    quantity: incomeItem.quantity,
    description: otherIncomeItem.description,
    itemPrice: otherIncomeItem.price,
    totalPrice: Number(total),
    calculationTotalPrice: total
  }
}

const cropCommodityItem = (incomeItemId, incomeItem, commodityItem) => {
  const total = costQuantityRateTotal(commodityItem.price, 1, incomeItem.production)

  return {
    id: incomeItemId,
    production: incomeItem.production,
    description: commodityItem.description,
    itemPrice: commodityItem.price,
    totalPrice: Number(total),
    calculationTotalPrice: total
  }
}

const cropCustomRateItem = (expenseItemId, expenseItem, customRateItem) => {
  const total = costQuantityRateTotal(customRateItem.cost, 1, expenseItem.quantity)

  return {
    id: expenseItemId,
    quantity: expenseItem.quantity,
    description: customRateItem.description,
    itemCost: customRateItem.cost,
    totalCost: Number(total),
    calculationTotalCost: total
  }
}

const cropOtherExpenseItem = (expenseItemId, expenseItem, otherExpenseItem) => {
  const total = costQuantityRateTotal(otherExpenseItem.cost, 1, expenseItem.quantity)

  return {
    id: expenseItemId,
    quantity: expenseItem.quantity,
    description: otherExpenseItem.description,
    itemCost: otherExpenseItem.cost,
    totalCost: Number(total),
    calculationTotalCost: total
  }
}

const cropChemicalItem = (expenseItemId, expenseItem, chemicalItem, convertUnit) => {
  const total = costQuantityRateTotal(chemicalItem.cost, convertUnit.quantity, expenseItem.applicationRate)

  return {
    id: expenseItemId,
    applicationRate: expenseItem.applicationRate,
    description: `${convertUnit.toUnit}, ${chemicalItem.description}`,
    itemCost: chemicalItem.cost,
    totalCost: Number(total),
    calculationTotalCost: total
  }
}

const cropFertilizerItem = (expenseItemId, expenseItem, fertilizerItem, convertUnit) => {
  const total = costQuantityRateTotal(fertilizerItem.cost, convertUnit.quantity, expenseItem.applicationRate)

  return {
    id: expenseItemId,
    applicationRate: expenseItem.applicationRate,
    description: `${convertUnit.toUnit}, ${fertilizerItem.description}`,
    itemCost: fertilizerItem.cost,
    totalCost: Number(total),
    calculationTotalCost: total
  }
}

const cropSeedItem = (expenseItemId, expenseItem, seedItem) => {
  const total = costQuantityRateTotal(seedItem.costPerUnit, seedItem.seedsPerUnit, expenseItem.seedingRate)

  return {
    id: expenseItemId,
    seedingRate: expenseItem.seedingRate,
    description: `${seedItem.description}`,
    itemCost: seedItem.costPerUnit,
    totalCost: Number(total),
    calculationTotalCost: total
  }
}

const cropIrrigationItem = (expenseItemid, expenseItem, irrigationItem) => {
  const total = costQuantityRateTotal(irrigationItem.cost, 1, expenseItem.quantity)

  return {
    id: expenseItemid,
    quantity: expenseItem.quantity,
    description: `${irrigationItem.description}`,
    itemCost: irrigationItem.cost,
    totalCost: Number(total),
    calculationTotalCost: total
  }
}

const presenters = {
  cropChemicalItem,
  cropCustomRateItem,
  cropOtherExpenseItem,
  cropFertilizerItem,
  cropIrrigationItem,
  cropSeedItem,
  cropCommodityItem,
  cropOtherIncomeItem
}

export default presenters
